module.exports = __webpack_public_path__ + "img/materials_tools_1.4e98c17c.png";